import { render, staticRenderFns } from "./ExPrimarySpinner.vue?vue&type=template&id=b6f24faa&scoped=true"
import script from "./ExPrimarySpinner.vue?vue&type=script&lang=js"
export * from "./ExPrimarySpinner.vue?vue&type=script&lang=js"
import style0 from "./ExPrimarySpinner.vue?vue&type=style&index=0&id=b6f24faa&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../account/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b6f24faa",
  null
  
)

export default component.exports